$(document).ready(function () {
  $(".collection_slider").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    prevArrow:
      '<div class="news__arrow news__arrow_dir_left"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="20.000000pt" height="34.000000pt" viewBox="0 0 20.000000 34.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,34.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"><path d="M17 333 c-17 -16 -3 -42 55 -100 l62 -63 -62 -63 c-34 -34 -62 -70 -62 -80 0 -36 39 -14 115 64 l78 80 -84 85 c-84 85 -90 89 -102 77z"/></g></svg></div>',
    nextArrow:
      '<div class="news__arrow news__arrow_dir_right"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="20.000000pt" height="34.000000pt" viewBox="0 0 20.000000 34.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,34.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"><path d="M17 333 c-17 -16 -3 -42 55 -100 l62 -63 -62 -63 c-34 -34 -62 -70 -62 -80 0 -36 39 -14 115 64 l78 80 -84 85 c-84 85 -90 89 -102 77z"/></g></svg></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: "unslick",
      },
    ],
  });

  if ($(window).width() < 1025) {
    $(".collection_sub_wapper").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      prevArrow:
        '<div class="news__arrow news__arrow_dir_left"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="20.000000pt" height="34.000000pt" viewBox="0 0 20.000000 34.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,34.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"><path d="M17 333 c-17 -16 -3 -42 55 -100 l62 -63 -62 -63 c-34 -34 -62 -70 -62 -80 0 -36 39 -14 115 64 l78 80 -84 85 c-84 85 -90 89 -102 77z"/></g></svg></div>',
      nextArrow:
        '<div class="news__arrow news__arrow_dir_right"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="20.000000pt" height="34.000000pt" viewBox="0 0 20.000000 34.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,34.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"><path d="M17 333 c-17 -16 -3 -42 55 -100 l62 -63 -62 -63 c-34 -34 -62 -70 -62 -80 0 -36 39 -14 115 64 l78 80 -84 85 c-84 85 -90 89 -102 77z"/></g></svg></div>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 767,
          settings: "unslick",
        },
      ],
    });
  }

  $(document).on("click", ".globo-formbuilder-open", function () {
    setTimeout(function () {
      $(".label-content").each(function () {
        var attr_get = $(this).attr("data-label");
        // console.log(attr_get);
        if (attr_get == "SKU") {
          var sku_get = $(this)
            .closest(".globo-form-control")
            .find(".globo-form-input")
            .addClass("sku_active");
          var sku_val = $("span.product-sku__value").text();
          var datasku = $(".globo-form-input.sku_active .classic-input").attr(
            "value",
            sku_val
          );
        }
        if (attr_get == "Weight") {
          var sku_get = $(this)
            .closest(".globo-form-control")
            .find(".globo-form-input")
            .addClass("weight_active");
          var sku_Weight = $(".product-weight__value").text();
          $(".globo-form-input.weight_active .classic-input").attr(
            "value",
            sku_Weight
          );
        }
      });
    }, 150);
  });

  // floor toggle open
  $(document).on("click", ".floor_finish_usage h5", function () {
    $(this).toggleClass("active");
    $(".floor_data").slideToggle();
  });

// Function to update gallons_total on variant change
function updateGallonsTotal(variantId) {
  var selectedVariant = variantData[variantId];

  if (!selectedVariant) {
    console.error("Selected variant data not found.");
    return;
  }

  var gallons_total = parseFloat(selectedVariant.gallons_total) || 1;
  $(".variant-metafield-gallons_total").attr("data-value", gallons_total);

  console.log("Updated gallons_total:", gallons_total);
  calculateFloorCost(); // Recalculate the cost with the updated gallons_total
}

// Variant change - update price & gallons
$(document).on("click", ".option-selector__btns .opt-label", function () {
  $(".floor_data #floor_enter").val("");
  $(".product_needed,.product_cost").text("");

  setTimeout(function () {
    // Get the selected variant ID from the page
    var variantId = $("input[name='id']").val();
    updateGallonsTotal(variantId);
  }, 200);
});

// Floor calculator
$(document).on("keyup change", ".floor_data #floor_enter", function () {
  calculateFloorCost();
});

function calculateFloorCost() {
  var value = parseFloat($(".floor_data #floor_enter").val());
  var price = parseFloat($(".current_var_price p").attr("data-price"));
  var coverage = parseFloat($(".coverage_value").attr("data-coverage"));
  var coats = parseFloat($(".coats_required").attr("data-coats"));
  var gallonsTotalElement = $(".variant-metafield-gallons_total");

  var gallons_total_attr = gallonsTotalElement.attr("data-value");
  var gallons_total = parseFloat(gallons_total_attr) || 1; // Default to 1 if not specified

  // Debugging Logs
  console.log("Value entered:", value);
  console.log("Price of the product listing:", price);
  console.log("Coverage per gallon:", coverage);
  console.log("Coats required:", coats);
  console.log("Gallons total:", gallons_total);

  if (value > 0 && !isNaN(gallons_total) && gallons_total > 0) {
    var qty = (value / coverage) * coats;
    qty = Math.ceil(qty);

    var multiplier = Math.ceil(qty / gallons_total);
    var total_price = price * multiplier;

    // Debugging Logs
    console.log("Quantity needed:", qty);
    console.log("Multiplier:", multiplier);
    console.log("Total price:", total_price);

    $(".product_needed").text(qty);

    function formatMoney(amount, currency) {
      var formatted = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency,
      }).format(amount);

      return formatted;
    }
    var data_curr = $("body").attr("data-currency");
    var formattedPrice = formatMoney(total_price, data_curr);
    $(".product_cost").text(formattedPrice);
  } else {
    $(".product_needed,.product_cost").text("");
  }
}

// Function to update gallons_total on variant change
function updateGallonsTotal(variantId) {
  var selectedVariant = variantData[variantId];

  if (!selectedVariant) {
    console.error("Selected variant data not found.");
    return;
  }

  var gallons_total = parseFloat(selectedVariant.gallons_total) || 1;
  $(".variant-metafield-gallons_total").attr("data-value", gallons_total);

  console.log("Updated gallons_total:", gallons_total);
}

// Variant change - update price & gallons
$(document).on("click", ".option-selector__btns .opt-label", function () {
  $(".floor_data #floor_enter").val("");
  $(".product_needed,.product_cost").text("");

  setTimeout(function () {
    // Get the selected variant ID from the page
    var variantId = $("input[name='id']").val();
    updateGallonsTotal(variantId);

    // Load the current_var_price and gallon_var_price first
    $(".current_var_price").load(
      location.href + " .current_var_price p",
      function () {
        $(".gallon_var_price").load(
          location.href + " .gallon_var_price p",
          function () {
            // Use the updated gallons_total for calculations
            var dilution_ratio = parseFloat($(".dilution_ratio").data("value"));
            var price_value = parseFloat(
              $(".product-price .product-info__price .price_current_data")
                .text()
                .replace("$", "")
            );
            var gallonsTotalElement = $(".variant-metafield-gallons_total");
            var gallons_total = parseFloat(gallonsTotalElement.attr("data-value")) || 1;

            console.log("Loaded price_value:", price_value); // Debug log
            console.log("Loaded dilution_ratio:", dilution_ratio); // Debug log
            console.log("Loaded gallons_total:", gallons_total); // Debug log

            if (
              !isNaN(price_value) &&
              !isNaN(dilution_ratio) &&
              !isNaN(gallons_total) &&
              gallons_total > 0
            ) {
              var final_value = (
                price_value /
                dilution_ratio /
                gallons_total
              ).toFixed(2);
              // console.log("Calculated final_value:", final_value); // Debug log
              $(".cost_per_gallon .final_value").text("$" + final_value);
            } else {
              $(".cost_per_gallon .final_value").text(""); // Clear the final value if any value is not valid
              // console.log("Invalid values for calculation"); // Debug log
            }
          }
        );
      }
    );
  }, 200);
});


  // **********************************************
  // ***** LOWEST FINAL COST Page calculator ******
  // **********************************************
  // ***** Used with Custom_calculator.liquid, main-product.liquid, & page.lowest-final-cost.json *****
  // **************************************************************************************************
  // Function to create custom dropdowns for the product selection
  function create_custom_dropdowns() {
    $(".cus_select").each(function (i, select) {
      // Check if a custom dropdown already exists
      if (!$(this).next().hasClass("dropdown-select")) {
        // Create custom dropdown elements and append them after the original select element
        $(this).after(
          '<div class="dropdown-select wide ' +
            ($(this).attr("class") || "") +
            '" tabindex="0"><span class="current"></span><div class="list"><ul></ul></div></div>'
        );
        var dropdown = $(this).next();
        var options = $(select).find("option");
        var selected = $(this).find("option:selected");
        // Set the currently selected option in the custom dropdown
        dropdown
          .find(".current")
          .html(selected.data("display-text") || selected.text());
        // Populate the custom dropdown list with options
        options.each(function (j, o) {
          var display = $(o).data("display-text") || "";
          dropdown
            .find("ul")
            .append(
              '<li class="option ' +
                ($(o).is(":selected") ? "selected" : "") +
                '" data-value="' +
                $(o).val() +
                '" data-display-text="' +
                display +
                '">' +
                $(o).text() +
                "</li>"
            );
        });
      }
    });

    // Add a search box above the dropdown list for filtering options
    $(".dropdown-select ul").before(
      '<div class="dd-search"><input id="txtSearchValue" autocomplete="off" class="dd-searchbox" type="text"></div>'
    );
  }

  // Event listener for opening and closing the custom dropdown
  $(document).on("click", ".dropdown-select", function (event) {
    // Prevent closing the dropdown when clicking inside the search box
    if ($(event.target).hasClass("dd-searchbox")) {
      return;
    }
    // Close other open dropdowns and toggle the current one
    $(".dropdown-select").not($(this)).removeClass("open");
    $(this).toggleClass("open");
    // Manage focus and tabindex for accessibility
    if ($(this).hasClass("open")) {
      $(this).find(".option").attr("tabindex", 0);
      $(this).find(".selected").focus();
    } else {
      $(this).find(".option").removeAttr("tabindex");
      $(this).focus();
    }
  });

  // Event listener to close the dropdown when clicking outside
  $(document).on("click", function (event) {
    // Check if the click was outside any dropdown
    if ($(event.target).closest(".dropdown-select").length === 0) {
      $(".dropdown-select").removeClass("open");
      $(".dropdown-select .option").removeAttr("tabindex");
    }
    event.stopPropagation();
  });

  // Event listener for selecting an option in the custom dropdown
  $(document).on("click", ".dropdown-select .option", function (event) {
    // Update the selected option and trigger change event on the original select element
    $(this).closest(".list").find(".selected").removeClass("selected");
    $(this).addClass("selected");
    var text = $(this).data("display-text") || $(this).text();
    $(this).closest(".dropdown-select").find(".current").text(text);
    $(this)
      .closest(".dropdown-select")
      .prev("select")
      .val($(this).data("value"))
      .trigger("change");
    // Display the calculator data section
    $(".calculator_data").css("display", "table");

    // Update the calculator with the selected product's data attributes
    var price = $(".product_data_main .cus_select option:selected").attr(
      "data-money"
    );
    var coverage = $(".product_data_main .cus_select option:selected").attr(
      "data-coverage"
    );
    var coats = $(".product_data_main .cus_select option:selected").attr(
      "data-coats"
    );
    $(".calculator_data #calculator_enter").val("");
    $(
      ".calculator_data .product__needed,.calculator_data .product__cost,.calculator_data .coverage__value,.calculator_data .coats__required"
    ).text("");
    $(".calculator_data .data__price").text(price);

    if (coverage != "") {
      $(".calculator_data .coverage__value").text(coverage);
    }
    if (coats != "") {
      $(".calculator_data .coats__required").text(coats);
    }
  });

  // Keyboard events for navigating the custom dropdown
  $(document).on("keydown", ".dropdown-select", function (event) {
    var focused_option = $(
      $(this).find(".list .option:focus")[0] ||
        $(this).find(".list .option.selected")[0]
    );
    // Enter key to select the focused option
    if (event.keyCode == 13) {
      if ($(this).hasClass("open")) {
        focused_option.trigger("click");
      } else {
        $(this).trigger("click");
      }
      return false;
      // Down arrow key to move focus to the next option
    } else if (event.keyCode == 40) {
      if (!$(this).hasClass("open")) {
        $(this).trigger("click");
      } else {
        focused_option.next().focus();
      }
      return false;
      // Up arrow key to move focus to the previous option
    } else if (event.keyCode == 38) {
      if (!$(this).hasClass("open")) {
        $(this).trigger("click");
      } else {
        focused_option.prev().focus();
      }
      return false;
      // Escape key to close the dropdown
    } else if (event.keyCode == 27) {
      if ($(this).hasClass("open")) {
        $(this).trigger("click");
      }
      return false;
    }
  });

  // Initialize the custom dropdowns
  create_custom_dropdowns();

  // Event listener for the calculator input field
  $(document).on(
    "keyup change",
    ".calculator_data #calculator_enter",
    function () {
      var value = parseFloat($(this).val());
      var price = parseFloat(
        $(".product_data_main .cus_select option:selected").attr("data-price")
      );
      var coverage = $(".product_data_main .cus_select option:selected").attr(
        "data-coverage"
      );
      var coats = $(".product_data_main .cus_select option:selected").attr(
        "data-coats"
      );

      // Calculate and display the product needed and total cost based on input value
      if (value > 0 && coverage != undefined && coats != undefined) {
        var qty = (value / coverage) * coats;
        qty = Math.ceil(qty);
        var total_price = price * qty;
        $(".calculator_data .product__needed").text(qty);

        function formatMoney(amount, currency) {
          var formatted = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currency,
          }).format(amount);
          return formatted;
        }
        var data_curr = $("body").attr("data-currency");
        var formattedPrice = formatMoney(total_price, data_curr);
        $(".calculator_data .product__cost").text(formattedPrice);
      } else {
        $(
          ".calculator_data .product__needed,.calculator_data .product__cost"
        ).text("");
      }
    }
  );

  // Event listener for the search box in the custom dropdown
  $(document).on("keyup change", "#txtSearchValue", function () {
    var valThis = $(this).val().toLowerCase();
    // Filter the options based on the search input
    $(".dropdown-select ul > li").each(function () {
      var text = $(this).text().toLowerCase();
      text.indexOf(valThis) > -1 ? $(this).show() : $(this).hide();
    });
  });
  // ******************** End of End Use Calculator (Flr Coverage to Coats to Product Needed to Cost) ************

  // Product page tab

  $(document).on("click", ".tabs-nav span", function () {
    // Check for active
    $(".tabs-nav li").removeClass("active");
    $(this).parent().addClass("active");

    // Display active tab
    let currentTab = $(this).attr("data-id");
    $(".tabs-content .tab_items").removeClass("tab_active");
    $(currentTab).addClass("tab_active");
    return false;
  });

  $(document).on("click", ".product_speci_tabs span", function () {
    // Check for active
    $(".product_speci_tabs span").removeClass("active");
    $(this).addClass("active");

    // Display active tab
    let currentTabs = $(this).attr("data-value");
    $(".product_information_specs_content .spec_tab_item").removeClass(
      "tab_active"
    );
    $(currentTabs).addClass("tab_active");
    return false;
  });

  $(document).on("click", ".acc__title", function () {
    var dropDown = $(this).closest(".acc__card").find(".acc__panel");
    // $(this).closest(".acc").find(".acc__panel").not(dropDown).slideUp();

    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    } else {
      $(this).closest(".acc").find(".acc__title.active").removeClass("active");
      $(this).addClass("active");
    }

    // dropDown.stop(false, true).slideToggle();
    var id =  $(this).closest(".acc__card").attr('id');
    //console.log(id);
    $('.tab_items .acc__panel').each(function() {
      var value = $(this).data('value');
      console.log(value);
      if(id == value){
        $(this).toggleClass('actives');
      }
       });
  });
});
